/* eslint max-len:0 */
/* eslint-disable react/no-typos */
import React, { useState } from 'react';
import cx from 'classnames';
import SvgIcon from '@move-ui/svg-icon';
import styles from './Star.module.css';
let idCounter = 0;
export const Star = ({ className, activeClassName, inactiveClassName, value = 1 }) => {
    const [starId] = useState(() => {
        idCounter += 1;
        return idCounter;
    });
    const id = `gradient-${value}-${starId}`;
    const offsetLeft = Math.round(value * 100);
    return (React.createElement(SvgIcon, { viewBox: "0 0 18 16", className: className, "data-value": value },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id },
                React.createElement("stop", { offset: `${offsetLeft}%`, className: cx(styles.active, activeClassName) }),
                React.createElement("stop", { offset: "0%", className: cx(styles.inactive, inactiveClassName) }))),
        React.createElement("polygon", { fill: `url(#${id})`, fillRule: "evenodd", points: "8.571 13.267 3.274 16 4.286 10.211 0 6.111 5.923 5.267 8.571 0 11.22 5.267 17.143 6.111 12.857 10.211 13.869 16" })));
};
//# sourceMappingURL=Star.js.map